import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6cf1b9b648b9001470cf30_1787398079302_19f983e1/wealthos/src/app/cookie-policy/page.tsx");
